/* Avalon marquee: swipe / drag on mobile.
   On screens <= 768px (or on every screen when the strip has data-avl-drag-always) a looping strip ([data-avl-drag]) is driven by JS instead of its CSS animation:
   it keeps drifting on its own, the visitor can swipe or drag it either way (with a bit of momentum),
   and it resumes drifting a moment after they let go. The track ([data-avl-drag-track]) holds N identical
   sets (data-avl-drag-sets), so wrapping by one set width is seamless. Vertical page scrolling still works. */
(function () {
  if (window.avalonMarqueeDrag) return;
  window.avalonMarqueeDrag = true;

  var mobile = window.matchMedia('(max-width: 768px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var RESUME_MS = 1800;

  function setup(root) {
    if (root.avlDragInit) return;
    root.avlDragInit = true;

    var track = root.querySelector('[data-avl-drag-track]');
    if (!track) return;
    var sets = parseInt(root.getAttribute('data-avl-drag-sets'), 10) || 2;
    var duration = parseFloat(root.getAttribute('data-avl-drag-duration')) || 30;
    // pause before it drifts again after a swipe (ms); data-avl-drag-resume="0" = it carries on straight away
    var resumeMs = parseFloat(root.getAttribute('data-avl-drag-resume'));
    if (isNaN(resumeMs)) resumeMs = RESUME_MS;

    var x = 0, setW = 0, speed = 0;
    var running = false, visible = true, dragging = false;
    var vx = 0, lastX = 0, lastT = 0, startX = 0, moved = false, resumeAt = 0, lastFrame = 0, raf = 0;

    function measure() {
      setW = track.scrollWidth / sets;
      speed = setW / duration; // px per second, same pace as the CSS loop
    }
    function apply() {
      if (setW > 0) x = ((x % setW) + setW) % setW;
      track.style.transform = 'translate3d(' + (-x).toFixed(2) + 'px,0,0)';
    }
    function enable() {
      if (running) return;
      running = true;
      root.classList.add('avl-drag-on');
      measure();
      lastFrame = performance.now();
      raf = requestAnimationFrame(frame);
    }
    function disable() {
      running = false;
      cancelAnimationFrame(raf);
      root.classList.remove('avl-drag-on');
      track.style.transform = '';
    }
    function sync() {
      // data-avl-drag-always: swipeable on every screen size (tablet and desktop too); otherwise phones only
      if ((mobile.matches || root.hasAttribute('data-avl-drag-always')) && !reduce.matches) enable(); else disable();
    }

    function frame(t) {
      if (!running) return;
      var dt = Math.min(0.05, (t - lastFrame) / 1000);
      lastFrame = t;
      if (visible && !dragging) {
        if (Math.abs(vx) > 20) {            // momentum after a flick
          x -= vx * dt;
          vx *= Math.pow(0.92, dt * 60);
          resumeAt = t + resumeMs;
        } else if (t >= resumeAt) {         // idle: drift
          vx = 0;
          x += speed * dt;
        }
        apply();
      }
      raf = requestAnimationFrame(frame);
    }

    root.addEventListener('pointerdown', function (e) {
      if (!running || (e.pointerType === 'mouse' && e.button !== 0)) return;
      dragging = true; moved = false; vx = 0;
      startX = lastX = e.clientX; lastT = e.timeStamp;
      try { root.setPointerCapture(e.pointerId); } catch (err) {}
    });
    root.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - lastX;
      var dtm = Math.max(1, e.timeStamp - lastT);
      if (Math.abs(e.clientX - startX) > 6) moved = true;
      x -= dx;
      vx = 0.8 * (dx / dtm * 1000) + 0.2 * vx; // content velocity, smoothed
      lastX = e.clientX; lastT = e.timeStamp;
      apply();
    });
    function end(e) {
      if (!dragging) return;
      dragging = false;
      resumeAt = performance.now() + resumeMs;
      if (e && e.timeStamp - lastT > 80) vx = 0; // paused before letting go: no flick
      try { root.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    root.addEventListener('pointerup', end);
    root.addEventListener('pointercancel', end);
    // A drag must not count as a click on a link inside the strip
    root.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    root.addEventListener('dragstart', function (e) { if (running) e.preventDefault(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(root);
    }
    window.addEventListener('resize', function () { if (running) measure(); });
    mobile.addEventListener ? mobile.addEventListener('change', sync) : mobile.addListener(sync);
    reduce.addEventListener ? reduce.addEventListener('change', sync) : reduce.addListener(sync);
    sync();
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-avl-drag]').forEach(setup);
  }
  scan(document);
  // Theme Editor re-renders sections as they are edited
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
